export default {
  state: {
    token: localStorage.getItem('user-token') || '',
    auth: false,
    role: 'guest',
    rolename: 'Гость',
    currentUser: {
      user: {},
      roles: [
        {
          name: ''
        }
      ],
      branch: '',
      image: '',
      courses: []
    }
  },
  mutations: {
    toggleAuth: (state, val) => {
      state.auth = val
    },
    AUTH_LOGOUT: (state) => {
      state.token = ''
      state.auth = false
      state.role = 'guest'
      state.rolename = 'Гость'
    },
    AUTH_LOGIN: (state, { token, role }) => {
      state.token = token
      state.auth = true
      state.role = role
      switch (role[0]) {
        case 'user':
          state.rolename = 'Студент'
          break
        case 'admin':
          state.rolename = 'Администратор'
          break
        case 'leader':
          state.rolename = 'Руководитель'
          break
        case 'leader_admin':
          state.rolename = 'Системный администратор'
          break
        case 'methodist':
          state.rolename = 'Методист'
          break
      }
    },
    SET_CURRENT_USER: (state, { user }) => {
      state.currentUser = user
    }
  },
  actions: {}
}
